import React from 'react';

import { getPublicRuntimeEnv } from '@tv2/lib-offspring/libs/publicEnv';
import { QueryClientProvider } from '@tv2/lib-offspring/api/graphql/QueryClientProvider';

import { usePrompt } from '../usePrompt';
import { ExtendedText } from './ExtendedText';
import { DefaultLayout } from './DefaultLayout';

const env = getPublicRuntimeEnv();

export function Prompt({ children }: { children?: React.ReactNode }) {
  return (
    <QueryClientProvider apiUrl={env.PROMPT_URL} isAdmin={false}>
      <PromptData>
        <QueryClientProvider apiUrl={env.API_URL} isAdmin={false}>
          {children}
        </QueryClientProvider>
      </PromptData>
    </QueryClientProvider>
  );
}

function PromptData({ children }: { children?: React.ReactNode }) {
  const prompt = usePrompt();
  const [showExtended, setShowExtended] = React.useState(false);
  const [extendedTextVisited, setExtendedTextVisited] = React.useState(false);

  if (!prompt) return children;
  if (showExtended) {
    return <ExtendedText backToPrompt={() => setShowExtended(false)} prompt={prompt} />;
  }

  switch (prompt.data.layout.__typename) {
    case 'DefaultLayout':
      return (
        <DefaultLayout
          prompt={prompt}
          extendedTextVisited={extendedTextVisited}
          openExtenedInfo={() => {
            setExtendedTextVisited(true);
            setShowExtended(true);
          }}
        />
      );
    default:
      return children;
  }
}
